import OrdersService from '@utility/services/order';

/**
 * The order a scanned barcode names, on a V2 account: the V2 orders search
 * (order number, channel order id, short Skupreme id) over every tab. The
 * legacy scan lookup reads Mongo and answers a Mongo id the V2 page may not
 * have. Null when nothing matches.
 */
export const findV2OrderByScan = async (
  scan: string,
): Promise<string | null> => {
  const search = scan.trim();
  if (!search) return null;
  const result = await OrdersService.get({ search, page: 1, limit: 1 });
  const [order] = (result?.data ?? []) as Array<{ _id?: string }>;
  return order?._id ?? null;
};
